/*
 * © 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/CardLogic/Card',['lodash', 'require', 'SolitaireShared/CardLogic/CardValue', 'SolitaireShared/CardLogic/CardColor', 'SolitaireShared/CardLogic/CardSuit'],
function (_, require, CardValue, CardColor, CardSuit) {

    var Card = function (supply, value, suit, deckNum, seq) {
        this.initCard(supply, value, suit, deckNum, seq);
    };


    Card.CardColor = {
        None: 0,
        Red: 1,
        Black: 2
    };

    Card.NumSuits = 4;
    Card.ValueNamesShort = ["JO", "A", "2", "3", "4", "5", "6", "7", "8", "9", "10", "J", "Q", "K"];
    Card.SuitNamesShort  = ["", "C", "D", "H", "S"];
    Card.NameLookup = {
        "ACE": "Ace",
        "2": "Two",
        "TWO": "Two",
        "3": "Three",
        "THREE": "Three",
        "4": "Four",
        "FOUR": "Four",
        "5": "Five",
        "FIVE": "Five",
        "6": "Six",
        "SIX": "Six",
        "7": "Seven",
        "SEVEN": "Seven",
        "8": "Eight",
        "EIGHT": "Eight",
        "9": "Nine",
        "NINE": "Nine",
        "10": "Ten",
        "TEN": "Ten",
        "JACK": "Jack",
        "QUEEN": "Queen",
        "KING": "King"
    };

    Card.NumValues = 13;

    Card.prototype.initCard = function (supply, value, suit, deckNum, seq) {
        this.Supply = supply;
        this.Value = value;
        this.Suit = suit;
        this.DeckNum = deckNum;
        this.Sequence = seq;

        this.Pile = null;
    };

    Object.defineProperty(Card.prototype, "Color", {
        get: function () {
            if (this.Suit == CardSuit.Clubs || this.Suit == CardSuit.Spades) {
                return Card.CardColor.Black;
            }
            else if (this.Suit == CardSuit.Diamonds || this.Suit == CardSuit.Hearts) {
                return CardColor.Red;
            }
            else {
                return CardColor.None;
            }
        }
    });

    Object.defineProperty(Card.prototype, "ValueNum", {
        get: function () {
            return this.Value;
        }
    });

    Object.defineProperty(Card.prototype, "SuitNum", {
        get: function () {
            return this.Suit;
        }
    });

    Card.prototype.GetThemeItem = function () {
        var suit = Card.SuitNamesShort[this.Suit];
        var value = Card.ValueNamesShort[this.Value];
        return (value + suit).toLowerCase();
    };

    Card.prototype.ToString = function () {
        return this.CardNameShort();
    };

    Card.prototype.CardNameShort = function () {
        var suit, value;
        if (this.Value == CardValue.Values.Joker)
        {
            suit = this.Suit;
            value = Card.ValueNamesShort[this.Value];
            return value + suit;
        }
        else
        {
            suit = Card.SuitNamesShort[this.Suit];
            value = Card.ValueNamesShort[this.Value];
            return value + suit;
        }
    };

    Card.prototype.CompareTo = function (o) {
        if (o instanceof Card) {
            return this.Sequence - o.Sequence;
        }
        return 0;
    };

    Card.GetSymbolStringFromShortName = function (name)
    {
        var upper = name.toUpperCase();
        switch (upper[name.length-1])
        {
            case 'D':
                return upper.replace('D', '♦');
            case 'C':
                return upper.replace('C', '♣');
            case 'H':
                return upper.replace('H', '♥');
            case 'S':
                return upper.replace('S', '♠');
        }
        return upper;
    };

    Card.GetShortValueString = function (value)
    {
        return Card.ValueNamesShort[value];
    };

    Card.GetLongValueName = function (key)
    {
        return Card.NameLookup[key.toUpperCase()];
    };

    return Card;
});

